export default __webpack_public_path__ + "static/media/request.6a3198d3.svg";